import { render, staticRenderFns } from "./SheetSamplesList.vue?vue&type=template&id=6daa32c7"
import script from "./SheetSamplesList.vue?vue&type=script&lang=js"
export * from "./SheetSamplesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6daa32c7')) {
      api.createRecord('6daa32c7', component.options)
    } else {
      api.reload('6daa32c7', component.options)
    }
    module.hot.accept("./SheetSamplesList.vue?vue&type=template&id=6daa32c7", function () {
      api.rerender('6daa32c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sheet-samples-list/SheetSamplesList.vue"
export default component.exports